var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.1875C4.53516 1.1875 3.20703 1.96875 2.46484 3.21875C1.74219 4.48828 1.74219 6.03125 2.46484 7.28125C3.20703 8.55078 4.53516 9.3125 6 9.3125C7.44531 9.3125 8.77344 8.55078 9.51562 7.28125C10.2383 6.03125 10.2383 4.48828 9.51562 3.21875C8.77344 1.96875 7.44531 1.1875 6 1.1875ZM6 10.25C4.20312 10.25 2.5625 9.3125 1.66406 7.75C0.765625 6.20703 0.765625 4.3125 1.66406 2.75C2.5625 1.20703 4.20312 0.25 6 0.25C7.77734 0.25 9.41797 1.20703 10.3164 2.75C11.2148 4.3125 11.2148 6.20703 10.3164 7.75C9.41797 9.3125 7.77734 10.25 6 10.25ZM4.41797 3.66797C4.59375 3.49219 4.88672 3.49219 5.0625 3.66797L5.98047 4.58594L6.89844 3.66797C7.09375 3.49219 7.38672 3.49219 7.5625 3.66797C7.75781 3.86328 7.75781 4.15625 7.5625 4.33203L6.64453 5.25L7.5625 6.16797C7.75781 6.36328 7.75781 6.65625 7.5625 6.83203C7.38672 7.02734 7.09375 7.02734 6.89844 6.83203L5.98047 5.91406L5.0625 6.83203C4.88672 7.02734 4.59375 7.02734 4.41797 6.83203C4.22266 6.65625 4.22266 6.36328 4.41797 6.16797L5.33594 5.25L4.41797 4.33203C4.22266 4.15625 4.22266 3.86328 4.41797 3.66797Z",
    fill: "black",
    fillOpacity: 0.64
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilter);
export default ForwardRef;